<template>
  <div class="content popup-resource">
    <!-- Condition Search -->
    <div class="popup-resource-filters custom-input mt-[20px] mb-[20px]">
      <el-input
        ref="refSearch"
        v-model="searchCondition.Search"
        placeholder="Search Worker ID or Name"
        size="large"
        class="popup-resource-filter-field popup-resource-filter-search"
        @change="handleSearch('filter')"
      />

      <el-select
        ref="refWorkerType"
        v-model="searchCondition.WorkerType"
        placeholder="Worker Type"
        size="large"
        class="popup-resource-filter-field popup-resource-filter-select"
        filterable
        clearable
        @change="handleSearch('filter')"
      >
        <el-option
          v-for="item in workerTypeOptions"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        />
      </el-select>

      <el-select
        v-model="searchCondition.LegalEntity"
        placeholder="Legal Entity"
        size="large"
        class="popup-resource-filter-field popup-resource-filter-select"
        filterable
        clearable
        @change="handleSearch('filter')"
      >
        <el-option
          v-for="item in legalEntityOptions"
          :key="item.id"
          :label="item.value"
          :value="item.id"
        />
      </el-select>

      <el-button
        class="btn-clear-filters btn-size-1 border-none popup-resource-filter-clear"
        @click="reset()"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M11.7256 10.25C12.4043 10.6473 13.1758 10.9033 13.9997 10.9775C13.9999 10.985 14 10.9925 14 11C14 11.4142 13.6642 11.75 13.25 11.75H4.75C4.33579 11.75 4 11.4142 4 11C4 10.5858 4.33579 10.25 4.75 10.25H11.7256ZM9.02242 6C9.06971 6.52473 9.19069 7.0282 9.37494 7.5H2.75C2.33579 7.5 2 7.16421 2 6.75C2 6.33579 2.33579 6 2.75 6H9.02242ZM12 15.25C12 14.8358 11.6642 14.5 11.25 14.5H6.75C6.33579 14.5 6 14.8358 6 15.25C6 15.6642 6.33579 16 6.75 16H11.25C11.6642 16 12 15.6642 12 15.25ZM14.5 10C16.9853 10 19 7.98528 19 5.5C19 3.01472 16.9853 1 14.5 1C12.0147 1 10 3.01472 10 5.5C10 7.98528 12.0147 10 14.5 10ZM16.3536 3.64645C16.5488 3.84171 16.5488 4.15829 16.3536 4.35355L15.2071 5.5L16.3536 6.64645C16.5488 6.84171 16.5488 7.15829 16.3536 7.35355C16.1583 7.54882 15.8417 7.54882 15.6464 7.35355L14.5 6.20711L13.3536 7.35355C13.1583 7.54882 12.8417 7.54882 12.6464 7.35355C12.4512 7.15829 12.4512 6.84171 12.6464 6.64645L13.7929 5.5L12.6464 4.35355C12.4512 4.15829 12.4512 3.84171 12.6464 3.64645C12.8417 3.45118 13.1583 3.45118 13.3536 3.64645L14.5 4.79289L15.6464 3.64645C15.8417 3.45118 16.1583 3.45118 16.3536 3.64645Z"
            :fill="currentTheme != 'light' ? '#fff' : '#3A4056'"
          />
        </svg>
        <span class="ml-2.5">Clear Filters</span>
      </el-button>
    </div>

    <div class="table-popup-resource-wrap" v-loading="loadingResource">
      <el-table
        ref="multipleTableRef"
        class="custom-table table-popup-resource"
        :data="filteredResourceList"
        :row-class-name="tableRowClassName"
        @row-click="rowClick"
      >
        <el-table-column width="55" class-name="text-center">
          <template #default="scope">
            <input
              class="cursor-pointer"
              type="checkbox"
              :checked="isSelected(scope)"
            />
          </template>
        </el-table-column>

        <el-table-column
          label="Worker ID"
          class-name="text-left"
          width="160"
          sortable
          prop="WorkerId"
        >
          <template #default="scope">
            {{ scope.row.WorkerId }}
          </template>
        </el-table-column>

        <el-table-column
          prop="WorkerName"
          label="Worker Name"
          class-name="text-left"
          min-width="200px"
        />

        <el-table-column
          prop="PersonnelNumber"
          label="Personnel Number"
          class-name="text-left"
          width="160px"
        />

        <el-table-column
          label="Worker Type"
          class-name="text-left"
          width="140px"
        >
          <template #default="scope">
            {{ getWorkerTypeLabel(scope.row.WorkerType) }}
          </template>
        </el-table-column>

        <el-table-column
          label="Legal Entity"
          class-name="text-left"
          width="120px"
        >
          <template #default="scope">
            {{ getLegalEntityName(scope.row.CompanyID) }}
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="pagination-custom mt-2 mb-2 flex flex-row-reverse">
      <el-pagination
        v-model:currentPage="currentPage"
        v-model:page-size="pageSize"
        :page-sizes="[20, 40, 100]"
        :small="small"
        :disabled="disabled || loadingResource"
        :background="background"
        layout="total, sizes, prev, pager, next"
        :total="resourceCount"
        popper-class="popper-class"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <div class="flex justify-end p-[0px] pt-2 pb-6">
      <el-button @click="handleClose()" class="btn-cancel">Cancel</el-button>
      <el-button
        type="primary"
        class="btn-confirm ml-[20px]"
        :disabled="!multipleSelection.length"
        @click="handleSubmit()"
      >
        <span>Ok</span>
      </el-button>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onBeforeMount,
  ref,
  watch,
} from "vue";
import { useStore } from "vuex";
import resourceService, { Resource, getWorkerTypeLabel } from "@/services/resource.service";

export default defineComponent({
  name: "PopupResource",
  props: {
    popupVisible: Boolean,
  },

  setup(props, ctx) {
    const store = useStore();
    const currentPage = ref(1);
    const pageSize = ref(20);
    const small = ref(false);
    const background = ref(true);
    const disabled = ref(false);
    const resourceList = ref<Resource[]>([]);
    const loadingResource = ref(false);
    const multipleSelection = ref<Resource[]>([]);
    const currentTheme = computed(() => store.state.currentTheme);

    const searchCondition = ref({
      Search: "",
      WorkerType: undefined as string | undefined,
      LegalEntity: undefined as string | undefined,
    });

    const workerTypeOptions = [
      { id: "0", value: "Employee" },
      { id: "1", value: "Contractor" },
    ];

    const legalEntityOptions = [
      { id: "13er", value: "Rental" },
      { id: "15fo", value: "Force" },
    ];

    // Client-side filtering removed - using OData server-side filtering

    const resourceCount = ref(0);

    // Direct list from server (no client-side pagination needed)
    const paginatedResourceList = computed(() => resourceList.value);

    watch(props, () => {
      if (!props.popupVisible) {
        reset();
      } else {
        handleSearch();
      }
    });

    onBeforeMount(() => {
      handleSearch();
    });



    const handleClose = () => {
      ctx.emit("closePopup");
      multipleSelection.value = [];
    };

    const isSelected = (scope: any) => {
      return multipleSelection.value.some(
        (item) => item.ResourceKey === scope?.row?.ResourceKey
      );
    };

    const tableRowClassName = ({
      row,
    }: {
      row: Resource;
      rowIndex: number;
    }) => {
      if (multipleSelection.value.find((e) => e.ResourceKey === row.ResourceKey)) {
        return "seleted-row";
      }
      return "";
    };

    const handleSearch = async (type?: string) => {
      if (type === "filter") {
        currentPage.value = 1;
      }

      loadingResource.value = true;
      try {
        // Build OData filter
        const filters: string[] = [];
        
        if (searchCondition.value.Search) {
          const searchLower = searchCondition.value.Search.toLowerCase();
          filters.push(`(contains(tolower(WorkerName), '${searchLower}') or contains(tolower(WorkerId), '${searchLower}'))`);
        }
        
        if (searchCondition.value.WorkerType) {
          filters.push(`WorkerType eq '${searchCondition.value.WorkerType}'`);
        }

        if (searchCondition.value.LegalEntity) {
          filters.push(`CompanyID eq '${searchCondition.value.LegalEntity}'`);
        }

        const params: any = {
          $top: pageSize.value,
          $skip: (currentPage.value - 1) * pageSize.value,
          $orderby: 'WorkerName',
          $count: true
        };
        
        if (filters.length > 0) {
          params.$filter = filters.join(' and ');
        }

        const response = await resourceService.getResources(params);
        resourceList.value = response.value || response;
        resourceCount.value = response['@odata.count'] || resourceList.value.length;
      } catch (error) {
        // Error fetching resources
        resourceList.value = [];
      } finally {
        loadingResource.value = false;
      }
    };

    const reset = () => {
      const filtersDirty =
        !!searchCondition.value.Search ||
        !!searchCondition.value.WorkerType ||
        !!searchCondition.value.LegalEntity;
      const pageDirty = currentPage.value !== 1;

      searchCondition.value = {
        Search: "",
        WorkerType: undefined,
        LegalEntity: undefined,
      };
      multipleSelection.value = [];
      currentPage.value = 1;

      if (filtersDirty || pageDirty) {
        handleSearch();
      }
    };

    const handleSubmit = () => {
      const selected = multipleSelection.value[0];
      if (!selected) {
        return;
      }
      ctx.emit("selectResource", selected);
      multipleSelection.value = [];
    };

    const handleSizeChange = (val: number) => {
      pageSize.value = val;
      currentPage.value = 1;
      handleSearch();
    };

    const handleCurrentChange = (val: number) => {
      currentPage.value = val;
      handleSearch();
    };

    const rowClick = (row: Resource) => {
      if (multipleSelection.value.find((e) => e.ResourceKey === row.ResourceKey)) {
        multipleSelection.value = [];
      } else {
        multipleSelection.value = [row];
      }
    };

    return {
      handleClose,
      searchCondition,
      reset,
      isSelected,
      handleSubmit,
      loadingResource,
      workerTypeOptions,
      legalEntityOptions,
      tableRowClassName,
      handleSearch,
      currentPage,
      pageSize,
      small,
      background,
      disabled,
      resourceCount,
      handleSizeChange,
      handleCurrentChange,
      filteredResourceList: paginatedResourceList,
      multipleSelection,
      currentTheme,
      rowClick,
      getLegalEntityName: (companyId: string | null | undefined): string => {
        if (!companyId) return '-';
        if (companyId === '13er') return 'Rental';
        if (companyId === '15fo') return 'Force';
        return companyId;
      },
      getWorkerTypeLabel,
    };
  },
});
</script>

<style lang="scss">
$--el-light-table-row-hover: #e5e5e5;
$--el-dark-table-row-active-hover: #2f3f62;
$--el-light-table-row-active-hover: rgba(36, 107, 253, 0.08);

.el-table.custom-table .el-table__header tr th {
  background: #231f20;
  color: #ffffff;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
}

.el-table.custom-table .el-table__header tr th:first-child {
  border-top-left-radius: 12px;
  padding-left: 24px;
}

.el-table.custom-table .el-table__header tr th:last-child {
  border-top-right-radius: 12px;
}

.el-table.custom-table tr td:first-child {
  padding-left: 24px;
}

.dark {
  .popup-resource {
    .el-table.custom-table .el-table__header {
      background-color: #252a34;
    }
    .el-table__header tr th {
      background: #3a4056;
      color: #ffffff;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
    }
    .table-popup-resource-wrap .table-popup-resource {
      .el-table__body-wrapper {
        min-height: 300px;
        background-color: #252a34;
      }
    }
  }
}

.table-popup-resource-wrap {
  border: 1px solid #e6e6e6;
  border-radius: 12px;
  min-height: 300px;
  overflow: hidden;
}

.table-popup-resource {
  border: none;
  border-radius: 12px;
  .el-table__body-wrapper {
    min-height: 300px;
  }
}

.dark {
  .table-popup-resource-wrap {
    border: 1px solid #3a4056;
  }
}

.popup-resource {
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  .popup-resource-filters {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;

    .popup-resource-filter-field {
      flex: 0 1 auto;
      width: 100%;
      max-width: 100%;
      min-width: 0;
    }

    .popup-resource-filter-search {
      width: 280px;
      max-width: 100%;
    }

    .popup-resource-filter-select {
      width: 200px;
      max-width: 100%;
    }

    .popup-resource-filter-clear {
      flex: 0 0 auto;
      width: auto;
      min-width: 142px;
      max-width: 100%;
    }
  }

  .el-table__header-wrapper {
    overflow: hidden;
    border-top-right-radius: 0px !important;
  }

  .el-table .el-table__cell {
    padding: 12px 0 10px 0;
    font-weight: 600;
    color: #231f20;
  }

  .el-table--striped
    .el-table__body
    tr.el-table__row--striped
    td.el-table__cell {
    border-color: none;
    cursor: pointer;
  }

  .el-table--enable-row-hover .el-table__body tr:hover td.el-table__cell,
  .el-table .el-table__body tr.el-table__row:hover td.el-table__cell {
    background: $--el-light-table-row-hover !important;
  }
  .el-table--enable-row-hover .el-table__body tr:hover td.el-table__cell,
  .el-table
    .el-table__body
    tr.el-table__row.seleted-row:hover
    td.el-table__cell {
    background: $--el-light-table-row-active-hover !important;
  }

  .el-table .seleted-row,
  .el-table--striped
    .el-table__body
    tr.el-table__row--striped.seleted-row
    td.el-table__cell {
    background: $--el-light-table-row-active-hover !important;
  }
  .seleted-row {
    position: relative;
  }
  .seleted-row::after {
    position: absolute;
    content: "";
    display: block;
    border-width: 2px;
    border-style: solid;
    border-color: #246bfd;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
  }
  .cell {
    padding: 0 !important;
    margin-right: 8px;
  }
  //checkbox
  input[type="checkbox"]:focus {
    outline: none;
    box-shadow: none;
  }
  [type="checkbox"] {
    background: transparent;
    border-width: 1px;
    border-radius: 2px;
  }
  [type="checkbox"]:checked {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e") !important;
  }
  [type="checkbox"]:hover {
    background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e") !important;
    background-color: #9398a0;
  }
  [type="checkbox"]:checked,
  [type="radio"]:checked {
    border-color: transparent;
    background-color: currentColor !important;
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.dark {
  .popup-resource {
    .btn-clear-filters {
      padding: 10px 16px !important;
      background: #262a34;
      color: #ffffff;
      border: 1px solid #3a4056 !important;
      &:hover {
        opacity: 0.8;
        background: #262a34 !important;
        box-shadow: 0 0 0 1px #262a34 inset;
      }
      &:focus {
        background: #262a34 !important;
      }
    }
    th .cell {
      color: #fff !important;
    }
    .el-table .el-table__cell {
      color: #fff;
    }
  }
}
.popup-resource {
  .btn-clear-filters {
    padding: 10px 16px !important;
    background: #fff;
    color: #262a34;
    border: 1px solid rgb(229, 231, 235) !important;
    &:hover {
      background-color: #fff !important;
      box-shadow: 0 0 0 1px rgba(35, 31, 32, 0.3) inset;
    }
    &:focus {
      background-color: #fff !important;
    }
    animation: all 0.5s ease-in;
  }
}

.el-dialog.popup-resource-dialog {
  margin-bottom: 0;
  .el-dialog__header {
    margin: 24px 16px 0 !important;
  }
  .el-dialog__body {
    height: calc(100vh - 178px);
    overflow-x: hidden;
    .content.popup-resource {
      height: inherit;
      padding-left: 16px;
      padding-right: 16px;
      box-sizing: border-box;
      .table-popup-resource-wrap {
        height: calc(100vh - 364px);
      }

      .custom-table.table-popup-resource {
        height: 100%;
      }
    }
  }
}

@media (min-width: 768px) {
  .el-dialog.popup-resource-dialog {
    .el-dialog__header {
      margin: 40px 0 0 40px !important;
    }
    .el-dialog__body .content.popup-resource {
      padding-left: 40px;
      padding-right: 40px;
    }
  }
}
</style>
